import { render, staticRenderFns } from "./FormRecommendation.vue?vue&type=template&id=f7c6a11c&"
import script from "./FormRecommendation.vue?vue&type=script&lang=js&"
export * from "./FormRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./FormRecommendation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports